<template>
  <div class="main">
    <iframe
      id="lyhistory"
      name="videoFrame"
      src="static/videoApi/history.html"
      frameborder="0"
    ></iframe>
    <Drawer
      title="车辆选择"
      placement="left"
      :closable="false"
      v-model="openVideo"
      width="250"
      :styles="{ padding: 0 }"
    >
      <p slot="header" style="display: none">选择车辆</p>
      <my-tree
        ref="fleetTree"
        modal="video"
        @car="reCarNo"
        v-if="openVideo"
        filterGroup="车辆"
      ></my-tree>
    </Drawer>
    <button hidden id="dasdf" @click="openVideo = true">ddddddd</button>
  </div>
</template>
<script>
import myTree from "../locate/locateToolCarPerson.vue";
export default {
  components: { myTree },
  data() {
    return {
      openVideo: false,
    };
  },
  methods: {
    reCarNo(v) {
      window["videoFrame"].window.reachData(v);
      this.openVideo = false;
      /* if (v.realTimeStatus == 3 || v.realTimeStatus == 4) {
      } else {
        this.$Modal.confirm({
          title: "发动机关会消耗电瓶，是否继续观看",
          //content: "退出系统后需要重新登录",
          onOk: () => {
            window["videoFrame"].window.reachData(v);
            this.openVideo = false;
          },
        });
      } */
    },
  },
};
</script>
<style>
#lyhistory {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/video/carVideoHistory.vue